<ng-container *ngIf="!aggregatedError">
  <div class="main-container" *ngIf="entity">
    <h2><strong>{{'entity-detail.title' | translate}}</strong></h2>
    <div class="flex flex-col items-center mt-6 justify-center">
      <ng-container *ngIf="entity.image">
        <img class="img-logo" [src]="entity.image" [alt]="entity.name">
      </ng-container>
      <ng-container *ngIf="!entity.image">
        <img class="img-logo-default" [src]="'assets/banks/bank-icon.svg'" [alt]="entity.name">
        <h2 class="text-regular mt-2">{{entity.name}}</h2>
      </ng-container>
    </div>
    <div class="flex justify-center items-center mt-6 mb-3 text-regular">
      <ng-container *ngIf="entity.status === constants.statusNames.oncourse">
        <strong [innerHTML]="'ONCOURSE' | translate"></strong>
      </ng-container>
      <ng-container
        *ngIf="entity.status === constants.statusNames.ok || entity.status === constants.statusNames.validating || (entity.status === constants.statusNames.ko && entity.statusMessage === 'NON_OWNER_ACCOUNT')">
        <img class="mr-1" src="assets/icons/tickagg.svg">
        <strong [innerHTML]="'COMPLETEDAGGREGATION' | translate"></strong>
      </ng-container>
      <ng-container
        *ngIf="entity.status === constants.statusNames.validating && categorizerService.ownershipValidation">
        <strong><i [innerHTML]="'VALIDATINGTITULARITY' | translate"></i></strong>
      </ng-container>
      <ng-container *ngIf="entity.status === constants.statusNames.ok && categorizerService.ownershipValidation">
        <img class="mr-1" src="assets/icons/tickagg.svg">
        <strong [innerHTML]="'VALIDATEDTITULARITY' | translate"></strong>
      </ng-container>
      <ng-container *ngIf="entity.status === constants.statusNames.ko && entity.statusMessage === 'NON_OWNER_ACCOUNT'">
        <img class="mr-1" src="assets/icons/advertisement-yellow.svg">
        <strong [innerHTML]="'TITULARITYVALIDATIONERROR' | translate"></strong>
      </ng-container>
      <ng-container *ngIf="entity.status === constants.statusNames.ko && entity.statusMessage !== 'NON_OWNER_ACCOUNT'">
        <img class="mr-1" src="assets/icons/closeagg.svg">
        <strong [innerHTML]="'AGGREGATIONERROR' | translate"></strong>
      </ng-container>
    </div>
    <div class="pb-3 d-flex error-advertisement text-small"
      *ngIf="entity.status === constants.statusNames.ko && entity.statusMessage !== 'NON_OWNER_ACCOUNT'">
      <img class="mt-1" src="assets/icons/advertisement-grey.svg" alt="">
      <p class="col-11 mb-0" [innerHTML]="'entity-detail.warning' | translate"></p>
    </div>
    <div class="pb-3 d-flex error-advertisement text-small"
      *ngIf="(entity.status === constants.statusNames.ok && isAnyAccountNotOwned()) || (entity.status === constants.statusNames.ko && entity.statusMessage === 'NON_OWNER_ACCOUNT')">
      <img class="mt-1" src="assets/icons/advertisement-grey.svg" alt="">
      <p class="col-11 mb-0" [innerHTML]="'TITULARITYERRORMESSAGE' | translate"></p>
    </div>
    <div class="flex flex-wrap justify-center mt-8" *ngIf="(entity.accounts || []).length > 0">
      <div *ngFor="let account of entity.accounts"
        class="table-content w-1/4 xs:w-full sm:w-1/2 md:w-1/3 px-2 py-3 m-2">
        <div class="table-content-info font-san-text-bold flex justify-between mb-1">
          <span class="truncate mr-2" [title]="account.productName">{{account.productName}}</span>
          <img *ngIf="entity.image" class="mr-1" [src]="getBlackBankIcon(entity.image)" alt="">
        </div>
        <div class="text-regular mb-1">
          <img *ngIf="entity.status !== constants.statusNames.validating && account.owner === false" class="mr-1"
            src="assets/icons/advertisement-yellow.svg">
          {{asteriskIban(account.iban || '')}}
        </div>
        <div class="flex justify-between items-end">
          <span class="text-regular-lighter" [innerText]="'AVAILABLE' | translate"></span>
          <div class="table-content-balance text-regular">
            <span>{{getBalanceInteger(account.balance || '')}},</span>
            <span class="balance-decimal">{{getBalanceDecimal(account.balance || '')}}€</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="btnr corporat">
    <button *ngIf="entity.status === constants.statusNames.ko && entity.statusMessage !== 'NON_OWNER_ACCOUNT'"
      type="button" id="continue" class="btn" (click)="continue()">
      {{'general.retry' | translate}}
      <svg class="arrow-icon" width="24px" height="24px" viewBox="0 0 24 24" version="1.1"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Group">
            <rect id="Rectangle" fill-opacity="0.01" fill="#FFFFFF" x="0" y="0" width="24" height="24"></rect>
            <g id="Group-6" transform="translate(3.000000, 4.000000)" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="2" stroke="var(--stroke-color)">
              <path
                d="M12,4.02884478 L4.59263626,11.7978009 C4.33511187,12.0673997 3.69318751,12.0673997 3.43519146,11.7978009 L-4,4"
                id="Stroke-133"
                transform="translate(4.000000, 8.000000) rotate(-270.000000) translate(-4.000000, -8.000000) "></path>
              <line x1="8.84910145" y1="-0.150898551" x2="8.84910145" y2="16.8491014" id="Stroke-135"
                transform="translate(9.349101, 8.500000) rotate(-270.000000) translate(-9.349101, -8.500000) "></line>
            </g>
          </g>
        </g>
      </svg>
    </button>
  </div>
  <button id="volver" class="btn-back" (click)="router.navigate([constants.url.index])"></button>
</ng-container>

<ng-container *ngIf="aggregatedError">
  <app-ag-error [noCancelButton]="true" [errorTitle]="'errors.500.title' | translate"
    [errorDescription]="'errors.500.description' | translate" [buttonText]="'general.out' | translate"
    (buttonClick)="goOutAppWithError()"></app-ag-error>
</ng-container>